module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("k5lOf"))).then(() => parcelRequire('9A6Te'));